export default __webpack_public_path__ + "static/media/Goal_2_Targets.32deb898.zip";